<ng-container [formGroup]="group">
  <label>{{ Title }}</label>
  <div class="row">
    <div bsMigration class="col-xs-7 col-sm-6 col-lg-4" [class.has-error]="group.invalid">
      <div class="input-group">

        <ng-container bsMigrationPicker [bs3]="typeDropDownBs3" [bs4]="typeDropDown">
          <ng-template #typeDropDown>
            <ng-container dropdown>
              <button bsMigration dropdownToggle type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false"><span class="hidden-xs">{{ PhoneType?.pht_code }} </span>
                <span class="caret"></span></button>
              <ul *dropdownMenu class="dropdown-menu" role="menu">
                <li role="menuitem"><a class="dropdown-item" href="#Mobile" (click)="changeType('Mobile', $event)"
                    [ngClass]="{'active': PhoneType?.pht_code == 'Mobile'}">Mobile</a></li>
                <li role="menuitem"><a class="dropdown-item" href="#Landline" (click)="changeType('Landline', $event)"
                    [ngClass]="{'active': PhoneType?.pht_code == 'Landline'}">Landline</a></li>
              </ul>
            </ng-container>
          </ng-template>
          <ng-template #typeDropDownBs3>
            <div class="input-group-btn">
              <ng-container *ngTemplateOutlet="typeDropDown"></ng-container>
            </div>
          </ng-template>
        </ng-container>

        <input type="tel" [class.is-invalid]="group.invalid" class="form-control" placeholder="###-###-####" formControlName="phn_number">
      </div>
    </div>
    <div bsMigration class="col-xs-5 col-sm-4 col-lg-3">
      <div class="input-group">
        <span bsMigration class="input-group-addon"><span
            class="visible-lg-inline visible-md-inline">Extension</span><span
            class="visible-xs-inline visible-sm-inline">Ext</span></span>
        <input type="text" class="form-control half" placeholder="####" formControlName="cph_extension">
      </div>
    </div>
    <div *ngIf="index > 0" class="col-sm-2">
      <button title="Delete" class="hidden-xs btn btn-danger" type="button" (click)="removePhone($event);">
        <fa-icon [icon]="faXmark"></fa-icon>
      </button>
      <p class="visible-xs-block">
        <a href="#Delete" title="Delete" class="text-danger" (click)="removePhone($event);">
          <fa-icon [icon]="faXmark"></fa-icon> Delete Phone Number
        </a>
      </p>
    </div>
  </div>
</ng-container>